import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import { AgentType, SecondaryAgentType } from "../../enums";

interface Props {
  type: AgentType | SecondaryAgentType;
  style?: React.CSSProperties;
}

export const AgentTypeLongNameTag = ({ type, style }: Props) => {
  const { t } = useTranslation();

  let color: string;

  switch (type) {
    case AgentType.NATURAL:
    case SecondaryAgentType.NATURAL:
      color = "blue";
      break;
    case AgentType.SELF_EMPLOYED:
    case SecondaryAgentType.SELF_EMPLOYED:
      color = "gold";
      break;
    case AgentType.LEGAL:
    case SecondaryAgentType.LEGAL:
      color = "purple";
      break;
  }

  return (
    <Tag style={style} color={color}>
      {`${t("agent.enums.type." + type)} - ${t("agent.helpers.agentTypeLongName." + type)}`}
    </Tag>
  );
};
